import { render, staticRenderFns } from "./workerdetail.vue?vue&type=template&id=b3ee4928&"
import script from "./workerdetail.vue?vue&type=script&lang=js&"
export * from "./workerdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports